<template>
  <div v-bind:class="{hide: !showForm, 'd-flex justify-content-center': showForm}"  class="w-100 ">
    <ChooseDocument />
  </div>
</template>

<script>
// @ is an alias to /src
import ChooseDocument from "@/components/ChooseDocument.vue";

export default {
  props: ["showForm"],
  name: "Home",
  components: {
    ChooseDocument
  }
};
</script>
